import { observer } from "mobx-react";
import React from "react";

import OfferIcon from "@components/icons/Offer";
import { EventOffer, SportOffer } from "@gp/offer";

export const CurrentScore = observer(function CurrentScore({
	sport,
	event,
}: {
	sport: SportOffer;
	event: EventOffer;
}) {
	return (
		<div className="event__stats__item">
			<div className="event__stats__label">
				<OfferIcon
					type="sport"
					sport={sport.abrv}
					className={
						"u-icon u-icon--tny u-icon--sport u-icon--sport--mono"
					}
					modifiers={{ mono: true }}
				/>
			</div>
			<div className="event__stats__result">
				<span>{event.currentScore?.home || 0}</span>
				<span> - </span>
				<span>{event.currentScore?.away || 0}</span>
			</div>
		</div>
	);
});
